import * as Sentry from "@sentry/vue";

export default {
  isAuthenticated: (state, getters) => {
    return getters.verifiedTokenClaims !== null;
  },

  /**
   * Parse the claims from the access token and return them with no additional checks.
   * @returns {object|null}
   */
  tokenClaims: (state) => {
    const token = state.accessToken;
    if (!token) {
      return null;
    }

    const tokenParts = token.split(".");
    if (!tokenParts || tokenParts.length < 2) {
      return null;
    }

    try {
      const data = Buffer.from(tokenParts[1], "base64").toString("utf8");
      return JSON.parse(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Failed to decode auth jwt", e);
      Sentry.captureException(e, { level: "warning" });
      return null;
    }
  },

  /**
   * Parse the claims from the access token, validate them, and log out if the token is invalid.
   * @returns {object|null}
   */
  verifiedTokenClaims: (state, getters) => {
    const claims = getters.tokenClaims;
    if (!claims) {
      return null;
    }

    const now = Math.floor(Date.now() / 1000);
    if (claims.exp && claims.exp < now) {
      return null;
    }

    return claims;
  },

  isGodAdmin: (state, getters) => {
    const tokenClaims = getters.verifiedTokenClaims;

    if (tokenClaims?.client_id?.includes("god_admin_")) {
      return true;
    }

    return false;
  },
};
